/* global axios */
import ApiClient from './ApiClient';

class OfficeHoursAPI extends ApiClient {
  constructor() {
    super('office_hours', { accountScoped: true });
  }

  // A singular resource: there is exactly one schedule per account, so there is no id
  // to address it by.
  update(data) {
    return axios.patch(this.url, data);
  }
}

export default new OfficeHoursAPI();
